var exports = {
  "J": "Label__Gu05ZA",
};

module.exports = exports;
